export default __webpack_public_path__ + "static/media/juegoexpediente_instrucciones.8ee8ac2b.png";